import { Box, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";

export default function InfoStep01() {

  const { getValues } = useFormContext()
  const { step01 } = getValues()
  
  return (
    <>
      <Box 
        sx={{
          display: 'flex',
          flexWrap: 'wrap'
        }}
      >
          <Box flexBasis="200px">
            <TableView
              title="Público"
              text={`${step01.publico.tipo_publico}${step01.publico.codigo_publico} - ${step01.publico.nome_pessoa}`}
            />
          </Box>
          <Box flexBasis="200px">
            <TableView
              title="Documento"
              text={`${step01.documento}`}
            />
          </Box>
          <Box flexBasis="200px">
            <TableView
              title="Banco"
              text={`${step01.banco.codigo} - ${step01.banco.nome}`}
            />
          </Box>
          <Box flexBasis="200px">
            <TableView
              title="Agência"
              text={`${step01.agencia} - ${step01.agencia_digito}`}
            />
          </Box>
          <Box flexBasis="200px">
            <TableView
              title="Conta"
              text={`${step01.conta} - ${step01.conta_digito}`}
            />
          </Box>
          <Box flexBasis="200px">
            <TableView
              title="Cheque"
              text={`${step01.numero_cheque} - ${step01.sequencia_cheque}`}
            />
          </Box>
      </Box>
    </>

  )
}

function TableView({ title, text }:TableViewProps) {
  return (
    <Box mb={1}>
      <Typography variant="subtitle2" color="textSecondary">
        {title}
      </Typography>
      <Typography variant="subtitle1">
        {text}
      </Typography>
    </Box>
  );
}

interface TableViewProps {
  title: string;
  text: string;
}